<template>
    <div class="gmap-actions">
        <RoundButton
            icon="paperplane"
            class="gmap-actions__btn"
            @click.native="onCenterClick()"
        />
        <RoundButton
            icon="plus"
            class="gmap-actions__btn"
            @click.native="onZoomClick(1)"
        />
        <RoundButton
            icon="minus"
            class="gmap-actions__btn"
            @click.native="onZoomClick(-1)"
        />
    </div>
</template>

<script>
import RoundButton from '../UI/RoundButton.vue'

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'MapActions',

    components: {
        RoundButton,
    },

    props: {
    },

    data() {
        return {
            //
        }
    },


    /* Life Cycle
    --------------------------------------------------------- */

    created() {
        //
    },


    mounted() {
        //
    },


    /* Data Handling
    --------------------------------------------------------- */


    computed: {
        //
    },


    watch: {
        //
    },


    /* Methods
    --------------------------------------------------------- */

    methods: {
        onZoomClick(inc) {
            this.$emit('mapaction:zoom', inc)
        },

        onCenterClick() {
            this.$emit('mapaction:center')
        },
    },


    /* Handlers
    --------------------------------------------------------- */


}

</script>
